// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.bookmark-modal-content {
  position: relative;
  z-index: 11;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 1.4;
  border-radius: 10px;
  max-width: 80%;
  min-width: 80%;
  min-height: 80%;
  max-height: 80%;
  text-align: left;
  overflow: hidden;
  background-color: #f9f9f9;
}
.bookmark-modal-content .modal-header {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  padding: 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #b6b6b6;
  background: #f1f1f1;
}
.bookmark-modal-content .modal-header > h2 {
  font-size: 0.9rem;
  font-weight: 600;
}
.bookmark-modal-content .close-modal {
  top: 20px;
}
.bookmark-modal-content .modal-body {
  position: fixed;
  top: 65px;
  left: 0;
  width: 100%;
  height: calc(100% - 65px);
  padding: 20px;
  overflow-y: scroll;
}
.bookmark-modal-content .modal-body .table-top {
  padding: 20px 0 10px;
}
.bookmark-modal-content .modal-body p {
  font-size: 16px;
  text-indent: 10px;
  position: relative;
}
.bookmark-modal-content .modal-body p::before {
  content: "";
  display: block;
  width: 2px;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 0px;
  transform: translateY(-50%);
  background-color: #ddd;
}
.bookmark-modal-content .modal-body::-webkit-scrollbar {
  width: 10px;
  background-color: #f1f1f1;
}
.bookmark-modal-content .modal-body::-webkit-scrollbar-thumb {
  width: 5px;
  height: 30%;
  background: #b6b6b6;
  border-radius: 10px;
}
.bookmark-modal-content .modal-body::-webkit-scrollbar-track {
  background: #eee;
  border-radius: 0 10px 10px 0;
  box-sizing: border-box;
}
.bookmark-modal-content .modal-body .commodity-table {
  width: 100%;
}
.bookmark-modal-content .modal-body .bookmarkRegist {
  width: 100%;
  margin-bottom: 30px;
}
.bookmark-modal-content .modal-body .bookmarkRegist > p {
  width: 100%;
}
.bookmark-modal-content .modal-body .bookmarkRegist .input {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
}
.bookmark-modal-content .modal-body .bookmarkRegist .input > input {
  display: block;
  width: 80%;
}
.bookmark-modal-content .modal-body .bookmarkRegist .input > button {
  display: block;
  width: 20%;
}
.bookmark-modal-content .modal-body .bookmark-table {
  position: relative;
}
.bookmark-modal-content .modal-body .bookmark-table .table-top {
  flex-wrap: wrap;
}
.bookmark-modal-content .modal-body .bookmark-table .bookmarkRegistButton {
  text-align: right;
  margin-top: -30px;
}
.bookmark-modal-content .modal-body .bookmark-table .bookmarkRegistButton > button {
  background-color: #222;
  color: #eee;
  padding: 9px 20px;
  width: 100px;
  height: 40px;
}
.bookmark-modal-content .modal-body table {
  position: relative;
  width: 100%;
  text-align: center;
}
.bookmark-modal-content .modal-body table::-webkit-scrollbar {
  width: 10px;
  background-color: #f1f1f1;
}
.bookmark-modal-content .modal-body table::-webkit-scrollbar-thumb {
  width: 5px;
  height: 30%;
  background: #b6b6b6;
  border-radius: 10px;
}
.bookmark-modal-content .modal-body table::-webkit-scrollbar-track {
  background: #eee;
  border-radius: 0 10px 10px 0;
  box-sizing: border-box;
}
.bookmark-modal-content .modal-body table tr th:nth-child(1) {
  width: 15%;
}
.bookmark-modal-content .modal-body table tr td:nth-child(1) {
  width: 10%;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  margin: 50px auto;
  padding-bottom: 0px;
}

.bookmark-slide-modal,
.slide-overlay {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  overflow: visible;
  z-index: 15;
}
.bookmark-slide-modal .slide-overlay,
.slide-overlay .slide-overlay {
  background: rgba(49, 49, 49, 0);
}
.bookmark-slide-modal .slide-modal-content,
.slide-overlay .slide-modal-content {
  position: relative;
  overflow-x: auto;
  top: 0;
  left: 10%;
  border-radius: 10px 0 0 10px;
  width: 90%;
  height: 100vh;
  text-align: left;
  z-index: 100;
}
.bookmark-slide-modal .slide-modal-content .modal-header,
.slide-overlay .slide-modal-content .modal-header {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  padding: 40px 30px 20px 30px;
  border-bottom: 1px solid #b6b6b6;
  background: #f1f1f1;
  z-index: 2;
}
.bookmark-slide-modal .slide-modal-content .modal-header > h2,
.slide-overlay .slide-modal-content .modal-header > h2 {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 10px;
}
.bookmark-slide-modal .slide-modal-content .modal-header > p,
.slide-overlay .slide-modal-content .modal-header > p {
  font-size: 12px;
  color: #949494;
}
.bookmark-slide-modal .slide-modal-content .close-modal,
.slide-overlay .slide-modal-content .close-modal {
  position: absolute;
  top: 40px;
  right: 30px;
  width: 24px;
  height: 24px;
  border: 1px solid #b6b6b6;
  border-radius: 12px;
  display: block;
  padding: 5px;
  cursor: pointer;
  transition: 0.2s;
  z-index: 3;
}
.bookmark-slide-modal .slide-modal-content .close-modal:hover,
.slide-overlay .slide-modal-content .close-modal:hover {
  background: #b6b6b6;
}
.bookmark-slide-modal .slide-modal-content .close-modal:hover::before, .bookmark-slide-modal .slide-modal-content .close-modal:hover::after,
.slide-overlay .slide-modal-content .close-modal:hover::before,
.slide-overlay .slide-modal-content .close-modal:hover::after {
  background-color: #eee;
}
.bookmark-slide-modal .slide-modal-content .close-modal::before, .bookmark-slide-modal .slide-modal-content .close-modal::after,
.slide-overlay .slide-modal-content .close-modal::before,
.slide-overlay .slide-modal-content .close-modal::after {
  content: "";
  position: absolute;
  width: 80%;
  height: 1px; /* 가로선 두께 설정 */
  background: #b6b6b6; /* 가로선 색상 설정 */
  top: 50%;
  left: 12%;
  transform: translateY(-50%);
  transition: 0.2s;
}
.bookmark-slide-modal .slide-modal-content .close-modal::before,
.slide-overlay .slide-modal-content .close-modal::before {
  transform: rotate(45deg);
}
.bookmark-slide-modal .slide-modal-content .close-modal::after,
.slide-overlay .slide-modal-content .close-modal::after {
  transform: rotate(-45deg);
}
.bookmark-slide-modal .slide-modal-content button,
.slide-overlay .slide-modal-content button {
  word-break: keep-all;
}
.bookmark-slide-modal .slide-modal-content .modal-body,
.slide-overlay .slide-modal-content .modal-body {
  position: relative;
  width: 100%;
  top: 95px;
  height: calc(100vh - 95px);
  padding: 30px;
  overflow: auto;
  z-index: 1;
  background-color: #f9f9f9;
}
.bookmark-slide-modal .slide-modal-content .modal-body::-webkit-scrollbar,
.slide-overlay .slide-modal-content .modal-body::-webkit-scrollbar {
  width: 10px; /* 스크롤바의 너비 */
  height: 10px;
  background-color: #f1f1f1;
}
.bookmark-slide-modal .slide-modal-content .modal-body::-webkit-scrollbar-thumb,
.slide-overlay .slide-modal-content .modal-body::-webkit-scrollbar-thumb {
  width: 5px;
  height: 30%; /* 스크롤바의 길이 */
  background: #b6b6b6; /* 스크롤바의 색상 */
  border-radius: 10px;
}
.bookmark-slide-modal .slide-modal-content .modal-body::-webkit-scrollbar-track,
.slide-overlay .slide-modal-content .modal-body::-webkit-scrollbar-track {
  background: #eee; /*스크롤바 뒷 배경 색상*/
  border-radius: 0 10px 10px 0;
  box-sizing: border-box;
}
.bookmark-slide-modal .slide-modal-content .modal-body table,
.slide-overlay .slide-modal-content .modal-body table {
  position: relative;
  width: 100%;
  text-align: center;
}
.bookmark-slide-modal .slide-modal-content .modal-body table tr th:nth-child(1),
.slide-overlay .slide-modal-content .modal-body table tr th:nth-child(1) {
  width: 15%;
}
.bookmark-slide-modal .slide-modal-content .modal-body table tr td:nth-child(1),
.slide-overlay .slide-modal-content .modal-body table tr td:nth-child(1) {
  width: 10%;
}`, "",{"version":3,"sources":["webpack://./src/scss/sub/_bookmark.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACC,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;AAED;AADC;EACC,eAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gCAAA;EACA,mBAAA;AAGF;AAFE;EACC,iBAAA;EACA,gBAAA;AAIH;AADC;EACC,SAAA;AAGF;AADC;EACC,eAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;AAGF;AAFE;EACC,oBAAA;AAIH;AAFE;EACC,eAAA;EACA,iBAAA;EACA,kBAAA;AAIH;AAHG;EACC,WAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAAA;AAKJ;AAFE;EACC,WAAA;EACA,yBAAA;AAIH;AAFE;EACC,UAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AAIH;AAFE;EACC,gBAAA;EACA,4BAAA;EACA,sBAAA;AAIH;AAFE;EACC,WAAA;AAIH;AAFE;EACC,WAAA;EACA,mBAAA;AAIH;AAHG;EACC,WAAA;AAKJ;AAHG;EACC,WAAA;EACA,aAAA;EACA,iBAAA;AAKJ;AAJI;EACC,cAAA;EACA,UAAA;AAML;AAJI;EACC,cAAA;EACA,UAAA;AAML;AADE;EACC,kBAAA;AAGH;AAFG;EACC,eAAA;AAIJ;AAFG;EACC,iBAAA;EACA,iBAAA;AAIJ;AAHI;EACC,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;AAKL;AADE;EACC,kBAAA;EACA,WAAA;EACA,kBAAA;AAGH;AAFG;EACC,WAAA;EACA,yBAAA;AAIJ;AAFG;EACC,UAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AAIJ;AAFG;EACC,gBAAA;EACA,4BAAA;EACA,sBAAA;AAIJ;AADI;EACC,UAAA;AAGL;AADI;EACC,UAAA;AAGL;;AAGA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;AAAD;;AAGA;;EAEC,WAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,iBAAA;EACA,WAAA;AAAD;AACC;;EACC,+BAAA;AAEF;AACC;;EACC,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,SAAA;EACA,4BAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;AAEF;AAAE;;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,4BAAA;EACA,gCAAA;EACA,mBAAA;EACA,UAAA;AAGH;AAFG;;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;AAKJ;AAHG;;EACC,eAAA;EACA,cAAA;AAMJ;AAHE;;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AAMH;AALG;;EACC,mBAAA;AAQJ;AAPI;;;EAEC,sBAAA;AAUL;AAPG;;;EAEC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA,EAAA,cAAA;EACA,mBAAA,EAAA,cAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;AAUJ;AAPG;;EACC,wBAAA;AAUJ;AAPG;;EACC,yBAAA;AAUJ;AAPE;;EACC,oBAAA;AAUH;AARE;;EACC,kBAAA;EACA,WAAA;EACA,SAAA;EACA,0BAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;EACA,yBAAA;AAWH;AAVG;;EACC,WAAA,EAAA,aAAA;EACA,YAAA;EACA,yBAAA;AAaJ;AAXG;;EACC,UAAA;EACA,WAAA,EAAA,aAAA;EACA,mBAAA,EAAA,aAAA;EACA,mBAAA;AAcJ;AAZG;;EACC,gBAAA,EAAA,eAAA;EACA,4BAAA;EACA,sBAAA;AAeJ;AAbG;;EACC,kBAAA;EACA,WAAA;EACA,kBAAA;AAgBJ;AAdK;;EACC,UAAA;AAiBN;AAfK;;EACC,UAAA;AAkBN","sourcesContent":[".bookmark-modal-content {\n\tposition: relative;\n\tz-index: 11;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\tline-height: 1.4;\n\tborder-radius: 10px;\n\tmax-width: 80%;\n\tmin-width: 80%;\n\tmin-height: 80%;\n\tmax-height: 80%;\n\ttext-align: left;\n\toverflow: hidden;\n\tbackground-color: #f9f9f9;\n\t.modal-header {\n\t\tposition: fixed;\n\t\twidth: 100%;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tpadding: 20px;\n\t\tbox-sizing: border-box;\n\t\tborder-bottom: 1px solid #b6b6b6;\n\t\tbackground: #f1f1f1;\n\t\t> h2 {\n\t\t\tfont-size: 0.9rem;\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n\t.close-modal {\n\t\ttop: 20px;\n\t}\n\t.modal-body {\n\t\tposition: fixed;\n\t\ttop: 65px;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: calc(100% - 65px);\n\t\tpadding: 20px;\n\t\toverflow-y: scroll;\n\t\t.table-top {\n\t\t\tpadding: 20px 0 10px;\n\t\t}\n\t\tp {\n\t\t\tfont-size: 16px;\n\t\t\ttext-indent: 10px;\n\t\t\tposition: relative;\n\t\t\t&::before {\n\t\t\t\tcontent: '';\n\t\t\t\tdisplay: block;\n\t\t\t\twidth: 2px;\n\t\t\t\theight: 100%;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 50%;\n\t\t\t\tleft: 0px;\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t\tbackground-color: #ddd;\n\t\t\t}\n\t\t}\n\t\t&::-webkit-scrollbar {\n\t\t\twidth: 10px;\n\t\t\tbackground-color: #f1f1f1;\n\t\t}\n\t\t&::-webkit-scrollbar-thumb {\n\t\t\twidth: 5px;\n\t\t\theight: 30%;\n\t\t\tbackground: #b6b6b6;\n\t\t\tborder-radius: 10px;\n\t\t}\n\t\t&::-webkit-scrollbar-track {\n\t\t\tbackground: #eee;\n\t\t\tborder-radius: 0 10px 10px 0;\n\t\t\tbox-sizing: border-box;\n\t\t}\n\t\t.commodity-table {\n\t\t\twidth: 100%;\n\t\t}\n\t\t.bookmarkRegist {\n\t\t\twidth: 100%;\n\t\t\tmargin-bottom: 30px;\n\t\t\t> p {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t\t.input {\n\t\t\t\twidth: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-wrap: nowrap;\n\t\t\t\t> input {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\twidth: 80%;\n\t\t\t\t}\n\t\t\t\t> button {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\twidth: 20%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.bookmark-table {\n\t\t\tposition: relative;\n\t\t\t.table-top {\n\t\t\t\tflex-wrap: wrap;\n\t\t\t}\n\t\t\t.bookmarkRegistButton {\n\t\t\t\ttext-align: right;\n\t\t\t\tmargin-top: -30px;\n\t\t\t\t> button {\n\t\t\t\t\tbackground-color: #222;\n\t\t\t\t\tcolor: #eee;\n\t\t\t\t\tpadding: 9px 20px;\n\t\t\t\t\twidth: 100px;\n\t\t\t\t\theight: 40px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\ttable {\n\t\t\tposition: relative;\n\t\t\twidth: 100%;\n\t\t\ttext-align: center;\n\t\t\t&::-webkit-scrollbar {\n\t\t\t\twidth: 10px;\n\t\t\t\tbackground-color: #f1f1f1;\n\t\t\t}\n\t\t\t&::-webkit-scrollbar-thumb {\n\t\t\t\twidth: 5px;\n\t\t\t\theight: 30%;\n\t\t\t\tbackground: #b6b6b6;\n\t\t\t\tborder-radius: 10px;\n\t\t\t}\n\t\t\t&::-webkit-scrollbar-track {\n\t\t\t\tbackground: #eee;\n\t\t\t\tborder-radius: 0 10px 10px 0;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t}\n\t\t\ttr {\n\t\t\t\tth:nth-child(1) {\n\t\t\t\t\twidth: 15%;\n\t\t\t\t}\n\t\t\t\ttd:nth-child(1) {\n\t\t\t\t\twidth: 10%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.pagination {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 5px;\n\tmargin: 50px auto;\n\tpadding-bottom: 0px;\n}\n\n.bookmark-slide-modal,\n.slide-overlay {\n\twidth: 100%;\n\theight: 100vh;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\toverflow: visible;\n\tz-index: 15;\n\t.slide-overlay {\n\t\tbackground: rgba(49, 49, 49, 0);\n\t}\n\n\t.slide-modal-content {\n\t\tposition: relative;\n\t\toverflow-x: auto;\n\t\ttop: 0;\n\t\tleft: 10%;\n\t\tborder-radius: 10px 0 0 10px;\n\t\twidth: 90%;\n\t\theight: 100vh;\n\t\ttext-align: left;\n\t\tz-index: 100;\n\n\t\t.modal-header {\n\t\t\tposition: absolute;\n\t\t\tleft: 0;\n\t\t\ttop: 0;\n\t\t\twidth: 100%;\n\t\t\tpadding: 40px 30px 20px 30px;\n\t\t\tborder-bottom: 1px solid #b6b6b6;\n\t\t\tbackground: #f1f1f1;\n\t\t\tz-index: 2;\n\t\t\t> h2 {\n\t\t\t\tfont-size: 17px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tmargin-bottom: 10px;\n\t\t\t}\n\t\t\t> p {\n\t\t\t\tfont-size: 12px;\n\t\t\t\tcolor: #949494;\n\t\t\t}\n\t\t}\n\t\t.close-modal {\n\t\t\tposition: absolute;\n\t\t\ttop: 40px;\n\t\t\tright: 30px;\n\t\t\twidth: 24px;\n\t\t\theight: 24px;\n\t\t\tborder: 1px solid #b6b6b6;\n\t\t\tborder-radius: 12px;\n\t\t\tdisplay: block;\n\t\t\tpadding: 5px;\n\t\t\tcursor: pointer;\n\t\t\ttransition: 0.2s;\n\t\t\tz-index: 3;\n\t\t\t&:hover {\n\t\t\t\tbackground: #b6b6b6;\n\t\t\t\t&::before,\n\t\t\t\t&::after {\n\t\t\t\t\tbackground-color: #eee;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&::before,\n\t\t\t&::after {\n\t\t\t\tcontent: '';\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 80%;\n\t\t\t\theight: 1px; /* 가로선 두께 설정 */\n\t\t\t\tbackground: #b6b6b6; /* 가로선 색상 설정 */\n\t\t\t\ttop: 50%;\n\t\t\t\tleft: 12%;\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t\ttransition: 0.2s;\n\t\t\t}\n\n\t\t\t&::before {\n\t\t\t\ttransform: rotate(45deg);\n\t\t\t}\n\n\t\t\t&::after {\n\t\t\t\ttransform: rotate(-45deg);\n\t\t\t}\n\t\t}\n\t\tbutton {\n\t\t\tword-break: keep-all;\n\t\t}\n\t\t.modal-body {\n\t\t\tposition: relative;\n\t\t\twidth: 100%;\n\t\t\ttop: 95px;\n\t\t\theight: calc(100vh - 95px);\n\t\t\tpadding: 30px;\n\t\t\toverflow: auto;\n\t\t\tz-index: 1;\n\t\t\tbackground-color: #f9f9f9;\n\t\t\t&::-webkit-scrollbar {\n\t\t\t\twidth: 10px; /* 스크롤바의 너비 */\n\t\t\t\theight: 10px;\n\t\t\t\tbackground-color: #f1f1f1;\n\t\t\t}\n\t\t\t&::-webkit-scrollbar-thumb {\n\t\t\t\twidth: 5px;\n\t\t\t\theight: 30%; /* 스크롤바의 길이 */\n\t\t\t\tbackground: #b6b6b6; /* 스크롤바의 색상 */\n\t\t\t\tborder-radius: 10px;\n\t\t\t}\n\t\t\t&::-webkit-scrollbar-track {\n\t\t\t\tbackground: #eee; /*스크롤바 뒷 배경 색상*/\n\t\t\t\tborder-radius: 0 10px 10px 0;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t}\n\t\t\ttable {\n\t\t\t\tposition: relative;\n\t\t\t\twidth: 100%;\n\t\t\t\ttext-align: center;\n\t\t\t\ttr {\n\t\t\t\t\tth:nth-child(1) {\n\t\t\t\t\t\twidth: 15%;\n\t\t\t\t\t}\n\t\t\t\t\ttd:nth-child(1) {\n\t\t\t\t\t\twidth: 10%;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
